import React from "react";
import Layout from "../components/Layout";
import "./History.css";
import { useUserAuth } from "../context/UserAuthContext";
import { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { v4 as uuid } from "uuid";
import Loading from "../components/Loading";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { storage } from "../FirebaseConfig";
export default function History() {
  const { user } = useUserAuth();
  const [dataUser, setDataUser] = useState();
  const [loading, setLoading] = useState(false);
  const getUserData = async () => {
    if (!user) return;
    setLoading(true);
    const docRef = doc(db, "users", user.email);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      // console.log("Document data:", docSnap.data().ImgPaths);
      setDataUser(docSnap.data().ImgPaths);
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
    setLoading(false);
  };

  useEffect(() => {
    getUserData();
  }, []);

  return (
    <Layout>
      <div className="user-container">
        {loading && <Loading />}
        <h1>Image Preview</h1>
        {user && <p>{`Username: ${user.email}`}</p>}

        <div className="user-container-imgs">
          <div style={{ display: "flex", alignItems: "center" }}>
            <h3
              style={{
                flex: "1",
                textAlign: "center",
                color: "rgb(69, 69, 69)",
              }}
            >
              <em style={{ borderBottom: "4px solid rgb(147, 227, 192)" }}>
                Image Original
              </em>
            </h3>
            <h3
              style={{
                flex: "1",
                textAlign: "center",
                color: "rgb(69, 69, 69)",
              }}
            >
              <em style={{ borderBottom: "4px solid rgb(147, 227, 192)" }}>
                {" "}
                Remove Background
              </em>
            </h3>
          </div>
          {dataUser &&
            dataUser.map((item) => {
              return (
                <div key={uuid()}>
                  <div className="src-container">
                    <img src={item.srcImg} alt="#" />
                    <button>
                      <a
                        style={{ textDecoration: "none", color: "#fff" }}
                        href={`${item.srcImg}`}
                        download
                        target="blank"
                      >
                        Download
                      </a>{" "}
                    </button>
                  </div>
                  <div className="pre-container">
                    <img src={item.predImg} alt="#" />

                    <button>
                      <a
                        style={{ textDecoration: "none", color: "#fff" }}
                        href={`${item.predImg}`}
                        download
                        // target="blank"
                      >
                        Download
                      </a>
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </Layout>
  );
}
